import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[400px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/2c391e5aca3075bf5e4e09a23f126dd8.jpg"
          alt="About Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-600/70"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white px-6">
            <h1 className="text-5xl font-bold mb-4">من نحن</h1>
            <p className="text-xl text-blue-50">نبني المستقبل بخبرة واحترافية</p>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">الأستاذ مصطفى محمد</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                نحن مؤسسة رائدة في تقديم الحلول الاحترافية والخدمات المتكاملة للشركات والأفراد. نفخر بخبرتنا الواسعة وفريقنا المتميز الذي يعمل بشغف لتحقيق أهداف عملائنا.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                منذ تأسيسنا، ونحن نسعى لتقديم أفضل الخدمات بجودة عالية واحترافية تامة، مع التركيز على بناء علاقات طويلة الأمد مع عملائنا.
              </p>
              <div className="flex gap-4">
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600 mb-2">+500</div>
                  <div className="text-gray-600">مشروع منجز</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600 mb-2">+300</div>
                  <div className="text-gray-600">عميل راضٍ</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
                  <div className="text-gray-600">سنة خبرة</div>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20business%20team%20meeting%20in%20modern%20office%2C%20diverse%20professionals%20collaborating%2C%20contemporary%20workspace%20with%20natural%20light%2C%20corporate%20environment%2C%20high%20quality%20business%20photography&width=600&height=700&seq=about-team-1&orientation=portrait"
                alt="Our Team"
                className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Vision Mission Values */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">رؤيتنا ورسالتنا</h2>
            <p className="text-xl text-gray-600">نؤمن بالتميز والابتكار في كل ما نقدمه</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {/* Vision */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-eye-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">رؤيتنا</h3>
              <p className="text-gray-700 leading-relaxed">
                أن نكون الخيار الأول والأكثر موثوقية في تقديم الحلول الاحترافية، ونساهم في نجاح عملائنا من خلال خدمات متميزة ومبتكرة.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-flag-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">رسالتنا</h3>
              <p className="text-gray-700 leading-relaxed">
                تقديم خدمات عالية الجودة تلبي احتياجات عملائنا وتتجاوز توقعاتهم، مع الالتزام بأعلى معايير الاحترافية والنزاهة.
              </p>
            </div>

            {/* Values */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">قيمنا</h3>
              <p className="text-gray-700 leading-relaxed">
                الاحترافية، الأمانة، الابتكار، التميز، والالتزام بتحقيق رضا العملاء في كل مشروع نقوم به.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">لماذا تختارنا؟</h2>
            <p className="text-xl text-gray-600">نقدم لك أسباباً قوية للثقة بنا</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">خبرة واسعة</h3>
              <p className="text-gray-600">أكثر من 15 سنة من الخبرة في المجال</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">فريق محترف</h3>
              <p className="text-gray-600">فريق عمل متخصص وذو كفاءة عالية</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">التزام بالمواعيد</h3>
              <p className="text-gray-600">نلتزم بتسليم المشاريع في الوقت المحدد</p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-customer-service-line text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">دعم مستمر</h3>
              <p className="text-gray-600">دعم فني متواصل بعد التسليم</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">فريق العمل</h2>
            <p className="text-xl text-gray-600">نخبة من المحترفين المتميزين</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { name: 'أحمد محمود', role: 'المدير التنفيذي', image: 'Professional business executive portrait, confident male professional in formal attire, modern office background, corporate headshot photography, high quality professional photo' },
              { name: 'سارة أحمد', role: 'مديرة المشاريع', image: 'Professional business woman portrait, confident female professional in business attire, modern office setting, corporate headshot photography, high quality professional photo' },
              { name: 'محمد علي', role: 'مدير التطوير', image: 'Professional technology expert portrait, confident male tech professional, modern workspace background, corporate headshot photography, high quality professional photo' }
            ].map((member, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                <img
                  src={`https://readdy.ai/api/search-image?query=$%7Bmember.image%7D&width=400&height=400&seq=team-${index + 1}&orientation=squarish`}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top"
                />
                <div className="p-6 text-center">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                  <p className="text-blue-600 mb-4">{member.role}</p>
                  <div className="flex justify-center gap-3">
                    <a href="#" className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors">
                      <i className="ri-linkedin-fill text-lg"></i>
                    </a>
                    <a href="#" className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center hover:bg-blue-600 hover:text-white transition-colors">
                      <i className="ri-twitter-fill text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">هل أنت مستعد للبدء؟</h2>
          <p className="text-xl text-blue-50 mb-8">
            دعنا نساعدك في تحقيق أهدافك من خلال خدماتنا الاحترافية
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/request-service"
              className="px-8 py-4 bg-white text-blue-600 rounded-full font-bold text-lg hover:bg-blue-50 transition-colors"
            >
              اطلب خدمة الآن
            </a>
            <a
              href="/contact"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-full font-bold text-lg hover:bg-white hover:text-blue-600 transition-colors"
            >
              تواصل معنا
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}